
export enum NotificationStatus {
	INITIAL = 'initial',
	PROCESSED = 'processed',
	DISMISSED = 'dismissed',
	COMPLETE = 'complete',
}

export enum NotificationPriority {

	HIGH = 'high',
	low = 'low',
}

export interface Notification {

	notification_type: string,
	process_id: number,
	to_email: string,
	from_email: string,
	notification_subject: string,
	notification_status: NotificationStatus,
	description: string,
	notification_id: number,
	priority: NotificationPriority,
	notification_body: string,
	update_timestamp: Date,
	attachment: string,
	ref_status: string,
	audit_event_id: string,
	recipient_guid: string,
	audit_app: string,
	display_cpg: boolean,
	display_map: boolean,
	create_timestamp: Date,
	notification_ref_id: string,
	custom_fields: any;
	is_mandatory?: boolean;
}


export interface NotificationState {
	notifications: Notification[],
	notificationLoaded: boolean,
}

export enum NotificationActions {
	SET_NOTIFICATION = 'SET_NOTIFICATION',
	SET_NOTIFCATION_READ = 'SET_NOTIFCATION_READ',
}
export enum NotificationTypes {
	URGENT = 'URGENT',
	WARNING = 'WARNING',
	INFORMATION = 'INFORMATION',
	POSITIVE = 'POSITIVE',
}

export enum MyCpgMidYearPersonalInfoAlertTypes {
	SPOUSE_CHILD_CHANGED = 'SPOUSE_CHILD_CHANGED',
	DOMESTIC_PARTNER_ESTABLISH = 'DOMESTIC_PARTNER_ESTALBISH',
	DOMESTIC_PARTNER_DISSOLVE = 'DOMESTIC_PARTNER_DISSOLVE',
	DOMESTIC_PARTNER_WARNING = 'DOMESTIC_PARTNER_WARNING',
	LIFE_EVENT_UPDATE = 'LIFE_EVENT_UPDATE',
	LIFE_EVENT_UPDATE_WARNING = 'LIFE_EVENT_UPDATE_WARNING',
	LIFE_EVENT_UPDATE_MARRIAGE = 'LIFE_EVENT_UPDATE_MARRIAGE',
	LIFE_EVENT_UPDATE_DIVORCE = 'LIFE_EVENT_UPDATE_DIVORCE',
	CHILD_ADD = 'CHILD_ADD',
	LIFE_EVENT_UPDATE_LEGAL_SEPARATION = 'LIFE_EVENT_UPDATE_LEGAL_SEPARATION',
}

export interface SiteWideNotification {

	siteToEnable: AlertSites,

	alertType: NotificationTypes,

	alertTitle: string,

	alertDescription: string,

	linkText: string,

	linkUrl: string,

	simpleUrl: string,

	startDateTime?: string,

	endDateTime?: string,

	alertKey?: any,
}

export enum AlertSites {
	ALL = 'All',
	CPGORG = 'CPG.ORG',
	TCSM = 'TCSM',
}

export interface NotificationItemMap {
	notificationRefId: string,
	subject: string,
	body: string,
	mandatory?: boolean,
}